import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { SetPasswordRequest, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useActivateUser(): UseMutationResult<
  AxiosResponse<void>,
  AxiosError<ErrorMessage>,
  SetPasswordRequest
> {
  return useMutation(request => client.post('/auth/activate/', request));
}
